export var InputMode;
(function (InputMode) {
    InputMode["NONE"] = "none";
    InputMode["TEXT"] = "text";
    InputMode["DECIMAL"] = "decimal";
    InputMode["NUMERIC"] = "numeric";
    InputMode["TEL"] = "tel";
    InputMode["SEARCH"] = "search";
    InputMode["EMAIL"] = "email";
    InputMode["URL"] = "url";
})(InputMode || (InputMode = {}));
//# sourceMappingURL=CsInputField.js.map